import { calculateTTCFromProposal } from "lib/shared/compensation/calculateTTCFromProposal";
import { Proposal } from "lib/shared/proposals/types";

import { getAnnualizedProposedSalary } from "./pay-frequency";

export const calculateOTEFromProposal = (proposal: Proposal, includeBonusTarget = true): number => {
  if (includeBonusTarget) return calculateTTCFromProposal(proposal);

  // @ts-expect-error TS2345
  const newSalary = getAnnualizedProposedSalary(proposal);

  const currentVariableTarget = proposal.owner?.variableTarget ?? 0;
  const newVariableTarget = proposal?.adjustVariableTarget ? proposal.variableTarget ?? 0 : 0;

  return newSalary + currentVariableTarget + newVariableTarget;
};
